// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, number, string } from 'prop-types'
import { useHandleDeleteAttachment } from './hooks'

const DeleteAttachment = props => {
  const handleDeleteAttachment = useHandleDeleteAttachment(props)

  return (
    <i
      className={'fa fa-times-circle-o margin-left-half pointer text-red'}
      id={`${props.idRoot}-trigger`}
      onClick={handleDeleteAttachment} />
  )
}

DeleteAttachment.propTypes = {
  commentFileId: number.isRequired,
  deleteAttachment: func.isRequired,
  idRoot: string.isRequired,
  removeSingleAttachmentFromComment: func.isRequired,
}

export default DeleteAttachment
